import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import { trackByValue } from '../../utils/track-by';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@Component({
  selector: 'rms-breadcrumbs',
  template: `
    <div class="flex items-center gap-2">
      <rms-breadcrumb>
        <a [routerLink]="['/']">
          <mat-icon
            svgIcon="mat:home"
            class="icon-sm" />
        </a>
      </rms-breadcrumb>
      @for (crumb of crumbs; track trackByValue($index, crumb)) {
        <div class="w-1 h-1 bg-gray-600 rounded-full"></div>
        <rms-breadcrumb>
          <a [routerLink]="[]">{{ crumb }}</a>
        </rms-breadcrumb>
      }
    </div>
  `,
  imports: [BreadcrumbComponent, RouterLink, MatIconModule],
})
export class BreadcrumbsComponent {
  @Input() public crumbs: string[] = [];

  public trackByValue = trackByValue;
}
